export default __webpack_public_path__ + "static/media/lyftLogo.d8ce1429.svg";